/**
 * LES PROPOSITIONS D'ADRESSE — depuis la Base Adresse Nationale.
 *
 * Amine, 19 septembre 2026 : « qu'on puisse marquer une adresse et qu'on ait
 * direct les propositions qui s'affichent ». L'API publique
 * (api-adresse.data.gouv.fr) rend des « features » GeoJSON ; ce module en
 * tire ce que le formulaire sait remplir — voie, code postal, ville — et se
 * teste sans réseau. La requête elle-même vit dans le composant.
 */

export interface SuggestionAdresse {
    /** La ligne complète, telle qu'on la lit dans le menu. */
    libelle: string;
    /** Numéro et voie — ce qui va dans le champ « Adresse ». */
    adresse: string;
    codePostal: string;
    ville: string;
}

export interface FeatureBAN {
    properties?: {
        label?: string;
        name?: string;
        postcode?: string;
        city?: string;
        type?: string;
        housenumber?: string;
        street?: string;
    };
}

/** Une réponse de l'API → des propositions propres, sans doublon, sans ligne vide. */
export function suggestionsDepuisBAN(features: FeatureBAN[] | null | undefined): SuggestionAdresse[] {
    const vues = new Set<string>();
    const resultat: SuggestionAdresse[] = [];
    for (const f of features ?? []) {
        const p = f?.properties ?? {};
        const adresse = String(p.name ?? p.street ?? '').trim();
        const codePostal = String(p.postcode ?? '').trim();
        const ville = String(p.city ?? '').trim();
        const libelle = String(p.label ?? '').trim() || [adresse, [codePostal, ville].filter(Boolean).join(' ')].filter(Boolean).join(' ');
        if (!libelle || !ville) continue;
        // Une commune seule (type « municipality ») ne remplit pas la voie.
        const suggestion: SuggestionAdresse = {
            libelle,
            adresse: p.type === 'municipality' ? '' : adresse,
            codePostal,
            ville,
        };
        const cle = `${suggestion.adresse}|${codePostal}|${ville}`.toLowerCase();
        if (vues.has(cle)) continue;
        vues.add(cle);
        resultat.push(suggestion);
    }
    return resultat;
}

/** À partir de combien de caractères on interroge : en dessous, trop de bruit. */
export const LONGUEUR_MINIMALE_RECHERCHE = 4;

export function vautLaPeineDeChercher(texte: string | null | undefined): boolean {
    const t = String(texte ?? '').trim();
    return t.length >= LONGUEUR_MINIMALE_RECHERCHE && /[a-zA-ZÀ-ÿ]/.test(t);
}
